import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styles from "./participantBooking.module.css";
import { TopHeader } from "../../../Components/TopHeaderNav/TopHeader";
import { CustomSelect } from "../../../Components/CustomSelect/CustomSelect";
import { useDispatch, useSelector } from "react-redux";
import { loadData } from "../../../Utils/localStorage";
import ImageUploading from "react-images-uploading";
import { EventConfig } from "../../../Events/EventConfig";
import { Textarea, TextInput } from "evergreen-ui";
import { ButtonColor } from "../../../Components/Button/Buttons/ButtonColor/ButtonColor";
import { toast } from "react-toastify";
import {
  eventFilter,
  getEventsDetailsbyId,
} from "../../../Components/Redux/eventsSlice";
import dayjs from "dayjs";
import { DateTimeRangeComponent } from "../../../Components/DateTimeRangeComponent/DateTimeRangeComponent";
import { Logo } from "../../../Components/Logo";
import { useSearchParams } from "react-router-dom";
import { TimePickerr } from "../../../Components/TimePicker/TimePickerr";
export const ParticipantBooking = ({
  open,
  onCloseModal,
  onOpen,
  failedStatus,
  setBookEventError,
}) => {
  const { profileDetails } = useSelector((state) => state.authSlice);
  const { eventsDetails } = useSelector((state) => state.eventsSlice);
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("event_id");
  const dispatch = useDispatch();
  const [btnStatus, setBtnStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [blocks, setBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState("");
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");

  const handleBlockChange = (selectedOption) => {
    setSelectedBlock(selectedOption);
    loadUnit(selectedOption?.value);
  };
  const handleUnitChange = (selectedOption) => {
    setSelectedUnit(selectedOption);
  };
  //--------------------------------------------
  //for loading Units
  const loadBlock = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/block/get-blocks`, {
      method: "POST",
      body: JSON.stringify({
        club_id: loadData("Club_id"),
        user_id: loadData("Token"),
        request_by: EventConfig.requestBy,
      }),
      headers: {
        "content-type": "application/json",
        Authorization: loadData("Auth"),
      },
    })
      .then((d) => d.json())
      .then((res) => {
        const blockOptions = res?.data?.map((block) => ({
          value: block?.block_id,
          label: block?.name,
        }));
        setBlocks(blockOptions);
      });
  };
  const loadUnit = (value) => {
    fetch(`${process.env.REACT_APP_API_URL}/api/unit/get-units`, {
      method: "POST",
      body: JSON.stringify({
        block_id: value,
        club_id: loadData("Club_id"),
        user_id: loadData("Token"),
        request_by: EventConfig.requestBy,
      }),
      headers: {
        "content-type": "application/json",
        Authorization: loadData("Auth"),
      },
    })
      .then((d) => d.json())
      .then((res) => {
        setSelectedUnit("");
        const unitOptions = res?.data?.map((unit) => ({
          value: unit?.ru_id,
          label: unit?.ru_num,
        }));
        setUnits(unitOptions);
      });
  };
  //-------------------------Dynaic Form---------------------------------------
  let dynamicFormError = true;
  const [participantForm, setParticipantForm] = useState();

  const handleChange = (e, index) => {
    const { name, value, type, checked } = e?.target;
    let list = [...participantForm];
    if (type === "checkbox") {
      const optionValue = value;
      if (checked) {
        list[index].value = [...(list[index].value || []), optionValue]; // add checked value
      } else {
        list[index].value = list[index].value.filter((v) => v !== optionValue); // remove unchecked value
      }
    } else {
      list[index].value = value;
    }

    setParticipantForm(list);
  };
  const handleDropdown = (e, index) => {
    let list = [...participantForm];
    list[index].value = e;
    setParticipantForm(list);
  };
  const handleDateTime = (e, index, name) => {
    let list = [...participantForm];
    list[index].value = e;
    setParticipantForm(list);
  };
  const handleDateRange = (e, index, name) => {
    let list = [...participantForm];
    if (name == "value1") {
      list[index][name] = e;
      list[index].value2 = e;
    } else {
      list[index][name] = e;
    }
    setParticipantForm(list);
  };
  const maxNumber = 1;
  const onChange = (imageList, index) => {
    let list = [...participantForm];
    list[index].value = imageList;
    setParticipantForm(list);
  };

  const onRemoveImage = (index) => {
    let list = [...participantForm];
    list[index].value = "";
    setParticipantForm(list);
  };

  const getSelecteFormDetailApi = (formId) => {
    setIsLoading(true);
    let payload = {
      club_id: loadData("Club_id"),
      user_id: loadData("Token"),
      request_by: EventConfig.requestBy,
      community_type: "AC_COMM",
      form_id: formId,
      request_from: "event_participant",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/event/get_form_details_by_id`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "content-type": "application/json",
        Authorization: loadData("Auth"),
      },
    })
      .then((d) => d.json())
      .then((res) => {
        setIsLoading(false);
        if (res?.success == true) {
          setParticipantForm(
            res?.data
              ?.filter((item) => item?.is_visible && item?.is_deleted == 0)
              ?.map((i, index) => {
                let field = {
                  label: i?.field_name,
                  type: i?.field_type,
                  fieldOrder: i?.event_form_id,
                  isMandatory: i?.is_mandatory,
                  options: i?.options?.map((j, index) => {
                    return {
                      label: j?.label,
                      value: i?.field_type === "checkbox" ? j?.label : j?.id,
                    };
                  }),
                  isVisible: i?.is_visible,
                  isDelete: i?.is_deleted,
                  formFieldId: i?.form_field_id,
                };
                // Handle date types (date, date_time, time)
                if (["date", "date_time", "time"].includes(i?.field_type)) {
                  field.value = dayjs();
                }
                // Handle date_range type
                else if (i?.field_type === "date_range") {
                  field.value1 = dayjs();
                  field.value2 = dayjs();
                } else if (i?.field_type === "checkbox") {
                  field.value = [];
                } else {
                  field.value = "";
                }
                return field;
              })
          );
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API response error:", err.message || "Unknown error");
      });
  };
  const handleBookEventSubmit = () => {
    if (btnStatus) {
      return;
    }
    if (Object.keys(selectedBlock)?.length <= 0 || selectedBlock?.value == "") {
      toast.error(
        `${
          profileDetails?.comm_type == "Federation Parent Community"
            ? "Please select Tenant"
            : profileDetails?.comm_type == "Federation Child Community"
            ? "Please select Tenant"
            : "Please select Block"
        }`
      );
    } else if (
      Object.keys(selectedUnit)?.length <= 0 ||
      selectedUnit?.value == ""
    ) {
      toast.error(
        `${
          profileDetails?.comm_type == "Federation Parent Community"
            ? "Please select Occupant"
            : profileDetails?.comm_type == "Federation Child Community"
            ? "Please select Employee"
            : "Please select unit no."
        }`
      );
    } else if (participantForm?.length > 0) {
      let validationErr = false;
      participantForm?.map((field, index) => {
        if (validationErr) {
          return;
        }
        const { label, isMandatory, options, type, value, value1, value2 } =
          field;

        // Check for mandatory fields
        if (field.type == "date_range") {
          if (isMandatory == 1 && (!value1 || !value2)) {
            toast(`${label} cannot be empty`, {
              type: "error",
            });
            validationErr = true;
            return;
          }
        } else if (field.type == "checkbox") {
          if (isMandatory == 1 && value.length < 1) {
            toast(`${label} cannot be empty`, {
              type: "error",
            });
            validationErr = true;
            return;
          }
        } else if (isMandatory == 1 && !value) {
          toast(`${label} cannot be empty`, {
            type: "error",
          });
          validationErr = true;
          return;
        }
      });
      if (!validationErr) {
        setBtnStatus(true);
        let payload = {
          club_id: loadData("Club_id"),
          user_id: loadData("Token"),
          request_by: "Admin",
          event_id: eventsDetails?.id,
          block_id: selectedBlock.label,
          ru_id: selectedUnit.label,
          ru_id_for_booking: selectedUnit.value,
          community_type: "AC_COMM",
          total_seats: 1,
        };
        if (participantForm?.length > 0) {
          let tempForm = participantForm?.map((i, index) => {
            let field = {
              field_name: i?.label,
              field_type: i?.type,
              is_mandatory: i?.isMandatory,
              form_field_id: i?.formFieldId,
            };
            if (i?.type === "single_choice") {
              field.field_value = [i?.value] || "";
            } else if (i?.type === "dropdown") {
              field.field_value = i?.value?.label || "";
            } else if (i?.type === "checkbox") {
              field.field_value = i?.value?.join() || "";
            } else if (i?.type === "file") {
              field.field_value = i?.value[0]?.data_url || "";
            } else if (i?.type === "date_range") {
              field.field_value = i?.value1 || "";
              field.field_value_end = i?.value2 || "";
            } else {
              field.field_value = i?.value || "";
            }
            return field;
          });
          payload["form_data"] = tempForm;
        }
        handleBookAdmin(payload);
      }
    }
  };
  const handleBookAdmin = (payload) => {
    fetch(
      process.env.REACT_APP_API_URL + "/api/event/admin_participant_register",
      {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "content-type": "application/json",
          Authorization: loadData("Auth"),
        },
      }
    )
      .then((d) => d.json())
      .then((res) => {
        if (res?.success == true) {
          //   dispatch(getEventsDetailsbyId(eventsDetails?.id));
          //   let args = {
          //     club_id: loadData("Club_id"),
          //     user_id: loadData("Token"),
          //     request_by: EventConfig.requestBy,
          //     event_id: eventId,
          //     limit: 4,
          //     offset: 0,
          //   };
          //   dispatch(getBookingHistoryById({ args, eventsActiveTab }));
          let payload = {
            club_id: loadData("Club_id"),
            user_id: loadData("Token"),
            request_by: EventConfig.requestBy,
          };
          setTimeout(() => {
            dispatch(eventFilter({ args: payload, paramId: eventId }));
          }, 2000);

          onCloseModal();
          onOpen();
          setBtnStatus(false);
        } else {
          setBtnStatus(false);
          setBookEventError(res.message);
          let payload = {
            club_id: loadData("Club_id"),
            user_id: loadData("Token"),
            request_by: EventConfig.requestBy,
          };
          failedStatus();
          setTimeout(() => {
            dispatch(eventFilter({ args: payload, paramId: eventId }));
          }, 2000);
        }
      })
      .catch((err) => {
        setBtnStatus(false);
      });
  };
  useEffect(() => {
    loadBlock();
    getSelecteFormDetailApi(eventsDetails?.participant_form_id);
  }, [open]);

  useEffect(() => {
    setSelectedBlock("");
    setSelectedUnit("");
  }, [onCloseModal]);

  return (
    <div>
      <Modal
        open={open}
        onClose={onCloseModal}
        showCloseIcon={true}
        center
        classNames={{
          modal: styles.customModal,
        }}
      >
        <div>
          <div className={styles.navDiv}>
            <TopHeader title={"Registration"} />
          </div>
          {isLoading ? (
            <div className={styles?.logoDiv}>
              <Logo />
            </div>
          ) : (
            <>
              <div className={styles.mainDiv}>
                <h2 className={styles.heading}>Basic Details</h2>
                <div className={styles.flexDiv}>
                  <div className={styles.fieldsDiv}>
                    <label className={styles.label}>
                      {" "}
                      {profileDetails?.comm_type ==
                      "Federation Parent Community"
                        ? "Tenant"
                        : profileDetails?.comm_type ==
                          "Federation Child Community"
                        ? "Tenant"
                        : "Block"}
                    </label>
                    <span style={{ color: "#FF443A" }}>*</span>
                    <div className={styles.dropDownDiv}>
                      <CustomSelect
                        padding={"4px 5px 4px 4px"}
                        border={"1px solid #DEDFE1"}
                        options={blocks}
                        value={selectedBlock}
                        name="block"
                        handleOnChangeDropdown={handleBlockChange}
                        // isEdit={isEdit}
                      />
                    </div>
                  </div>
                  <div className={styles.fieldsDiv}>
                    <label className={styles.label}>
                      {profileDetails?.comm_type ==
                      "Federation Parent Community"
                        ? "Occupant"
                        : profileDetails?.comm_type ==
                          "Federation Child Community"
                        ? "Employee"
                        : "Unit no."}
                    </label>
                    <span style={{ color: "#FF443A" }}>*</span>
                    <div className={styles.dropDownDiv}>
                      <CustomSelect
                        padding={"4px 5px 4px 4px"}
                        border={"1px solid #DEDFE1"}
                        options={units}
                        value={selectedUnit}
                        name="unit"
                        handleOnChangeDropdown={handleUnitChange}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.dynamicFormDiv}>
                  {participantForm?.map((item, index) => {
                    if (item?.type === "text") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <TextInput
                            className={styles.inputText}
                            value={item?.value}
                            onChange={(e) => handleChange(e, index)}
                            autoComplete="off"
                          />
                        </div>
                      );
                    } else if (item?.type === "numeric") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <TextInput
                            className={styles.inputText}
                            type={"number"}
                            value={item?.value}
                            onChange={(e) => handleChange(e, index)}
                            autoComplete="off"
                          />
                        </div>
                      );
                    } else if (
                      item?.type === "text_area" ||
                      item?.type === "long_text"
                    ) {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <Textarea
                            className={styles.inputTextArea}
                            value={item?.value}
                            onChange={(e) => handleChange(e, index)}
                          />
                        </div>
                      );
                    } else if (item?.type === "dropdown") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <div style={{ marginTop: "12px" }}>
                            <CustomSelect
                              options={item?.options}
                              value={item?.value}
                              name="type"
                              handleOnChangeDropdown={(e) => {
                                handleDropdown(e, index);
                              }}
                              padding={"4px"}
                              border={"none"}
                            />
                          </div>
                        </div>
                      );
                    } else if (item.type === "single_choice") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <div className={styles.dynamicRadioDiv}>
                            {item.options.map((option, i) => (
                              <span
                                key={i}
                                className={
                                  item.value == option.value
                                    ? styles.radioDivActive
                                    : styles.radioDiv
                                }
                              >
                                <input
                                  type="radio"
                                  name={item.label}
                                  value={option.value}
                                  checked={item.value == option.value}
                                  onChange={(e) => handleChange(e, index)}
                                  className={styles.radioInput}
                                  width={300}
                                  height={44}
                                />

                                <label className={styles.radioLabel}>
                                  {option.label}
                                </label>
                              </span>
                            ))}
                          </div>
                        </div>
                      );
                    } else if (item.type === "checkbox") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <div className={styles.dynamicRadioDiv}>
                            {item.options.map((option, i) => (
                              <span
                                key={i}
                                className={
                                  item.value?.includes(String(option.value))
                                    ? styles.radioDivActive
                                    : styles.radioDiv
                                }
                              >
                                <input
                                  type="checkbox"
                                  name={item.label}
                                  value={option.value}
                                  checked={
                                    item.value?.includes(
                                      String(option.value)
                                    ) || false
                                  }
                                  onChange={(e) => handleChange(e, index)}
                                  className={styles.radioInput}
                                  width={300}
                                  height={44}
                                />

                                <label className={styles.radioLabel}>
                                  {option.label}
                                </label>
                              </span>
                            ))}
                          </div>
                        </div>
                      );
                    } else if (item?.type === "time") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <div className={styles.dateDiv}>
                            <TimePickerr
                              timeName={item?.label}
                              handleTimePicker={(e) => handleDateTime(e, index)}
                              customWidth={"100%"}
                              value={item?.value || dayjs()}
                              dynamicValue={true}
                            />
                          </div>
                        </div>
                      );
                    } else if (item?.type === "date") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <div className={styles.dateDiv}>
                            <DateTimeRangeComponent
                              Name={item?.label}
                              handleDateTimePicker={(e) =>
                                handleDateTime(e, index)
                              }
                              showOnlyDate={true}
                              value={item?.value || dayjs()}
                              dynamicValue={true}
                            />
                          </div>
                        </div>
                      );
                    } else if (item?.type === "date_time") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <div className={styles.dateDiv}>
                            <DateTimeRangeComponent
                              Name={item?.label}
                              value={item?.value || dayjs()}
                              handleDateTimePicker={(e) =>
                                handleDateTime(e, index)
                              }
                              dynamicValue={true}
                            />
                          </div>
                        </div>
                      );
                    } else if (item?.type === "date_range") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <div className={styles.dateRangeDiv}>
                            <div>
                              <DateTimeRangeComponent
                                Name={item?.label}
                                handleDateTimePicker={(e) =>
                                  handleDateRange(e, index, "value1")
                                }
                                showOnlyDate={true}
                                value={item?.value1}
                                dynamicValue={true}
                              />
                            </div>
                            <div>
                              <DateTimeRangeComponent
                                Name={item?.label}
                                handleDateTimePicker={(e) =>
                                  handleDateRange(e, index, "value2")
                                }
                                showOnlyDate={true}
                                value={item?.value2}
                                minDate={item?.value1}
                                dynamicValue={true}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    } else if (item?.type === "file") {
                      return (
                        <div className={styles.fieldDiv} key={index}>
                          <label className={styles.label}>{item?.label}</label>
                          {item?.isMandatory ? (
                            <span className={styles.star}>*</span>
                          ) : (
                            ""
                          )}
                          <br />
                          <div className={styles.ImgUploadMainDiv}>
                            <ImageUploading
                              multiple={false}
                              value={item?.value}
                              onChange={(imageList) =>
                                onChange(imageList, index)
                              }
                              maxNumber={maxNumber}
                              dataURLKey="data_url"
                              acceptType={["jpg", "jpeg", "png"]}
                              // maxFileSize="3500000"
                              // resolutionWidth={900}
                              // resolutionHeight={440}
                              resolutionType="absolute"
                            >
                              {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps,
                                errors,
                              }) => (
                                <div className={styles.uploadImgDiv}>
                                  <div className={styles.previewDiv}>
                                    {imageList.map((image, idx) => (
                                      <div
                                        key={idx}
                                        className={styles.imgIconDiv}
                                        onClick={() => onImageRemove(idx)}
                                      >
                                        <div
                                          className={styles.closeIcon}
                                          onClick={() => {
                                            onRemoveImage(index);
                                          }}
                                        >
                                          <img
                                            src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_IMAGES}/cancelEventActive.png`}
                                            alt="removeIcon"
                                          />
                                        </div>
                                        <img src={image.data_url} alt="" />
                                      </div>
                                    ))}
                                    {item?.value?.length < 1 && (
                                      <div className={styles.ImageDiv}>
                                        <div className={styles.imgIconDiv}>
                                          <img
                                            src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_IMAGES}/ImageUpload.png`}
                                          />
                                        </div>
                                        <p>
                                          <span style={{ color: "#121212" }}>
                                            Upload Image
                                          </span>
                                          {/* <span>(Less than 3.5mb)</span> */}
                                        </p>
                                      </div>
                                    )}
                                  </div>

                                  {item?.value?.length < 1 && (
                                    <button
                                      onClick={onImageUpload}
                                      className={styles.browseBtn}
                                    >
                                      Browse
                                    </button>
                                  )}
                                  {errors?.maxFileSize && (
                                    <span className={styles.error}>
                                      Selected file size exceed Max File Size
                                    </span>
                                  )}
                                  {errors?.acceptType && (
                                    <span className={styles.error}>
                                      Selected file type is not allowed
                                    </span>
                                  )}
                                  {errors?.resolution && (
                                    <span className={styles.error}>
                                      Selected file does not match your desired
                                      resolution
                                    </span>
                                  )}
                                </div>
                              )}
                            </ImageUploading>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </div>
              <div className={styles.btnDiv}>
                <div>
                  <p className={styles.rupee}>FREE</p>
                </div>

                <ButtonColor
                  text="Book"
                  width="200"
                  buttonHandler={() => {
                    handleBookEventSubmit();
                  }}
                  isDisabled={btnStatus}
                />
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};
